/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import EventsConfiguration from "./EventsConfiguration/EventsConfiguration";
import TrapReceive from "./TrapReceive/TrapReceive";
import CustomEvents from "./CustomEvents/CustomEvents";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../components/ui/tabs";

const tabData = [
  { key: "events-configuration", label: "Events Configuration", component: <EventsConfiguration /> },
  { key: "trap-receive", label: "Trap Receive", component: <TrapReceive /> },
  { key: "custom-events", label: "Custom Events", component: <CustomEvents /> },
];

const FaultManagements: React.FC = () => {
  return (
    <Tabs defaultValue={tabData[0].key} className="w-full">
      <div className="pl-4 pr-1 mt-4">
        <div style={{ borderBottom: "1px solid var(--color-border)" }}>
          <TabsList className="inline-flex h-auto gap-0 rounded-none border-0 bg-transparent p-0 text-muted-foreground shrink-0">
            {tabData.map((tab) => (
              <TabsTrigger
                key={tab.key}
                value={tab.key}
                className="rounded-none border-b-2 border-transparent bg-transparent px-4 py-2 text-sm capitalize text-muted-foreground data-[state=active]:border-primary data-[state=active]:text-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none"
              >
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
      </div>
      {tabData.map((tab) => (
        <TabsContent key={tab.key} value={tab.key} className="pt-4">
          {tab.component}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default FaultManagements;